<template>
  <div>
    <a href="" class="btn btn-primary btn-bigger-font btn-black mr-2" @click.prevent="showPasswordResetModal = true">Reset Password</a>

    <modal v-if="showPasswordResetModal" @close="showPasswordResetModal = false">
      <h3 slot="header">Reset Password</h3>
      <div class="content" slot="body">
        <p>You will receive an email with password reset instructions.</p>
        <p class="green" v-if="message">{{ message  }}</p>
        <div class="form-group">
          <label for="email" class="col-12">E-Mail Address</label>
          <input id="email" type="email" v-model="user.email" name="email">
        </div>

      </div>
      <div class="form-group-submit" slot="footer">
        <button class="pull-left" @click.prevent="showPasswordResetModal = false">Close</button>
        <button class="btn btn-cancel btn-transparent pull-right" @click.prevent="resetPassword">Send Password Reset Email</button>
      </div>
    </modal>
  </div>
</template>

<script>
import modal from '../components/Modal.vue';

export default {
  props: ['user'],
  components: {modal},
  data() {
    return {
      showPasswordResetModal: false,
      message: '',
    }
  },
  methods: {
    resetPassword() {
      let app = this;
      window.axios(
          {
            method: 'post',
            url: '/password/email',
            data: {
              email: app.user.email
            }
          }).then(function(response) {
            app.message = 'A password reset email was sent'
        setTimeout(function() {
          app.showPasswordResetModal = false;
        }, 5000)
      }).catch(function (error) {
        // handle error
        console.log('This is the error returned', error);
      });
    }
  }
}

</script>